import { render, staticRenderFns } from "./CustomizeChoose.vue?vue&type=template&id=1dce4cae&scoped=true&"
import script from "./CustomizeChoose.vue?vue&type=script&lang=js&"
export * from "./CustomizeChoose.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeChoose.vue?vue&type=style&index=0&id=1dce4cae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce4cae",
  null
  
)

export default component.exports